module.exports = __webpack_public_path__ + "img/play.1eb9c059.svg";